import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../../context/LanguageContext";
import { useWalletContext } from "../../../../context/WalletContext";
import { EMIONBOARDINGSTATUS } from "../../../../constants";
import { handleApi } from "../../../../apis";
import { POST_INCREASE_ACCOUNT_LIMIT } from "../../../../apis/configuration";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import AccountLimitOverview from "./AccountLimitOverview";
import IncreaseLimitForm from "./IncreaseLimitForm";
import LimitIncreaseInProcess from "./LimitIncreaseInProcess";

const AccountLimit = () => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { walletData, accountLimit, loadingAccountLimit, getAccountLimit } =
    useWalletContext();
  const { showSnackbar } = useSnackbar();


  const [limitIncreaseInprocess, setLimitIncreaseInProcess] = useState(false);
  const [loadingIncreaseLimit, setLoadingIncreaseLimit] = useState(false);
  const [increaseLimit, setIncreaseLimit] = useState(false);
  const [files, setFiles] = useState([]);
  const [ntnNumber, setNtnNumber] = useState("");

  const increaseButtonDisable =
    walletData?.account_info?.agent_status !== "NO-REQUEST";

  const handleIncreaseLimit = async () => {
    try {
      triggerLogEvent(analytics, "w_acc_limit_submit");
      setLoadingIncreaseLimit(true);
      const docs = files.map((item) => ({
        document_type: item?.type,
        document: item?.file?.split(",")[1],
      }));
      const payload = {
        ntn_info: {
          have_ntn: ntnNumber ? "Yes" : "No",
          ntn_number: ntnNumber,
        },
        documents: docs,
      };
      const response = await handleApi(POST_INCREASE_ACCOUNT_LIMIT, payload);
      setLoadingIncreaseLimit(false);

      if (response?.success && response?.message) {
        setLimitIncreaseInProcess(true);
        getAccountLimit();
        showSnackbar({
          message: response?.message,
          severity: "success",
        });
      } else if (!response?.success && response?.message) {
        showSnackbar({
          message: response?.message,
          severity: "error",
        });
      }
    } catch (error) {
      setLoadingIncreaseLimit(false);
      showSnackbar({
        message:
          error.response?.data?.message ||
          I18n.something_went_wrong_please_try_again,
        severity: "error",
      });
    }
  };

  if (limitIncreaseInprocess) {
    return <LimitIncreaseInProcess />;
  }

  if (increaseLimit) {
    return (
      <IncreaseLimitForm
        loadingAccountLimit={loadingAccountLimit}
        files={files}
        setFiles={setFiles}
        ntnNumber={ntnNumber}
        setNtnNumber={setNtnNumber}
        loadingIncreaseLimit={loadingIncreaseLimit}
        onBack={() => setIncreaseLimit(false)}
        onSubmit={handleIncreaseLimit}
      />
    );
  }

  return (
    <AccountLimitOverview
      accountLimit={accountLimit}
      loadingAccountLimit={loadingAccountLimit}
      increaseButtonDisable={increaseButtonDisable}
      onIncreaseLimit={() => {
        triggerLogEvent(analytics, "w_acc_limit_increase_start");
        setIncreaseLimit(true);
      }}
    />
  );
};

export default AccountLimit;
